/* globals Ajax,Class,jui,lp */
var jQuery = require('jquery');
var _      = require('lodash');

var ubBanzai = require('ub/control/banzai-features');
var sandbox = require('ub/control/sandbox/sandbox');

var AssetBrowser = require('ub/lp/editor/ub-asset-browser.js');
var endpoints = require('ub/config/endpoints').default;

require('ub_legacy/lp/editor/builder_modal.js'); // added to window scope

var rxUi = window.rxUi;

module.exports = Class.create( lp.editor.BuilderModal, {
  initialize: function($super){
    /* jshint unused:vars */
    this._uiBinding = new rxUi.Binding(['AssetChooser']);
    var upload = !ubBanzai.features.isSandboxEnabled();
    this.controlStates = {choose:false, cancel:true, upload:upload};
    this.lastUploadId = null;
    this.enabled = true;
    // $super( options );

    $super({
      title:'Choose Image',
      actions: [{
        id: 'choose',
        label: 'Choose',
        attributes: {className: "button action js-asset-upload-choose-btn modal-choose-action-button modal-button"},
        action: this._uiBinding.wrapCallbackWithData('assetChooserChoose', this.add.bind(this))
      },
      {
        id: 'cancel',
        label: 'Cancel',
        attributes: {className: "button js-asset-upload-cancel-btn push-left modal-cancel-action-button modal-button"},
        action: this._uiBinding.wrapCallbackWithData('assetChooserCancel', this.cancel.bind(this))
      }],
      layoutRules: {
        method: jui.ModalDialog.centerInViewPort
      },
      attributes: {
        className: 'modal-panel responsive-panel asset-library'
      },
      closeX: true
    });
  },

  installUI: function( $super ) {
    $super();

    var browserOptions = {
      size:{width:640,height:400},
      views:[
      {label:'Images', id:'images'}
      ],
      change: function(e) {
        e.data.view.buildSearch();
      }
    };

    this.assetBrowser = this.contentPanel.insert( new AssetBrowser(browserOptions));
    this.assetUploader = this.actionBar.insert( new lp.editor.AssetUploader(_.merge(browserOptions, {assetBrowser: this.assetBrowser, assetChooser: this})));

    var self = this;
    this.assetBrowser.addListener('assetSelectionChanged', function(){
      self.controlStates.choose = (self.assetBrowser.getSelectedAssets().length === 1);
      self.updateControlStates();
    });

    this.assetBrowser.addListener('assetDblClicked', function(asset) {
      self.addByAsset(asset.data);
    });

    this.assetBrowser.addListener('assetsLoaded', this);
    this.assetUploader.addListener('assetUploaded', this);
    this.assetUploader.addListener('assetUploadFailed', this);
    this.assetBrowser.addListener('enabled', function(){
      self.enable();
    });
    this.assetBrowser.addListener('disabled', function(){
      self.disable();
    });
    this.assetBrowser.addListener('updated', function() {
      self.update();
    });

    this.updateControlStates();
  },

  enable: function() {
    this.enabled = true;
    this.updateControlStates();
  },

  disable: function() {
    this.enabled = false;
    this.updateControlStates();
  },

  setEnabled: function(enable) {
    this[enable ? 'enable' : 'disable']();
  },

  updateControlStates: function() {
    this.actionButtons.choose.setEnabled(this.enabled && this.controlStates.choose);
    this.actionButtons.cancel.setEnabled(this.enabled && this.controlStates.cancel);
    this.assetUploader.setEnabled(this.enabled && this.controlStates.upload);
  },

  assetsLoaded: function() {
    if (this.options.selectedAsset && this.options.selectedAsset.content_content_type) {
      var asset = this.options.selectedAsset;
      this.assetBrowser.showTabWithContentType(asset.content_content_type);
      this.assetBrowser.selectedTabViewItem.view.triggerSelectAsset(asset);

      this.scrollToAsset(this.options.selectedAsset.uuid);
    }

    this.assetBrowser.e.removeClassName('loading');
  },

  assetUploaded: function(e) {
    var asset            = e.data,
        currentCompanyId = window.editor.currentCompanyId;

    this.assetUploader.reset();
    this.assetBrowser.showTabWithContentType(asset.content_content_type);
    this.assetBrowser.addAsset(asset);
    if(this.assetBrowser.openAssetsCompanyId === currentCompanyId) {
      this.assetBrowser.selectedTabViewItem.view.triggerSelectAsset(asset);
    } else {
      this.assetBrowser.loadAssetsByCompanyId(currentCompanyId);
      this.options.selectedAsset = asset;
    }
  },

  assetUploadFailed: function(e) {
    var error = e.data;
    this.showErrorDialog(error);
  },

  dismissErrorDialog: function($super) {
    $super();
    this.assetUploader.reset();
  },

  cancel: function() {
    this.assetBrowser.clearSelection();
    if (Object.isFunction(this.options.onCancel)){
      this.options.onCancel();
    }
    this.assetUploader.cancel();
    this.close();
  },

  add: function() {
    var asset = this.assetBrowser.getSelectedAsset();
    this.addByAsset(asset);
  },

  addByAsset: function(asset) {
    if(asset) {
      this.assetBrowser.clearSelection();
      if (Object.isFunction(this.options.onChoose)){
        this.options.onChoose(asset);
      }
      this.close();
    }

  },

  update: function() {
    var asset = this.assetBrowser.getUpdatedAsset();
    if(Object.isFunction(this.options.onUpdate)) {
      this.options.onUpdate(asset);
    }
  },

  open: function($super, options) {
    options = options || {};

    this.options.onChoose = options.onChoose;
    this.options.onCancel = options.onCancel;
    this.options.selectedAsset = options.selectedAsset;

    window.editor.activeAssetUploader = this.assetUploader;
    this.config(options);
    this.controlStates.choose = false;
    this.updateControlStates();
    this.assetUploader.reset();
    this.assetBrowser.e.addClassName('loading');

    $super();
    this._updateUploadMultiFilesMessage(options.onlyImages);

    if (ubBanzai.features.isSandboxEnabled()) {
      sandbox.initTooltips([{
        selector: ".upload-images-button",
        copy: "Have images like photos or logos you'd like to use? Upload them here. " +
        "See how it works by starting a trial.",
        disabled: true,
        color: 'white',
        size: 'large',
        position: 'fixed'
      }]);
    }
  },

  scrollToAsset: function(assetUUID) {
    var $assetElm = jQuery('#container_' + assetUUID);

    if ($assetElm.length) {
      var parentDivTop = $assetElm.parent().offset().top;
      $assetElm.parent().parent().scrollTop($assetElm.offset().top - parentDivTop);
    }
  },

  close: function($super) {
    this.assetBrowser.clear();
    this.options.onChoose = null;
    this.options.onCancel = null;
    this.options.selectedAsset = null;
    $super();
  },

  config: function(options) {
    /* JS: defaults to images for convenience */
    var companyId = window.editor.currentCompanyId;
    this.url = options.url || endpoints.imageAssetsByCompanyId(companyId);

    this.setTitle(options.title || "Choose Image");

    if (options.selectedAsset) {
      //If the asset does not have a company id try to get one by uuid.  If it still does not have a company id
      //than use the current companyId for that asset.
      var currentAssetCompanyId = options.selectedAsset.company_id;
      if(currentAssetCompanyId && this.isValidCompany(currentAssetCompanyId)) {
        companyId = currentAssetCompanyId;
      } else {
        companyId = this.companyIdByAssetUUID(options.selectedAsset.uuid);
      }
    }
    this.assetUploader.setButtonLabel(options.uploadButtonLabel || "Upload New Images");
    this.assetUploader.setOnlyImages(Object.isUndefined(options.onlyImages) ? true : options.onlyImages);
    if (options.onlyImages) {
      this.assetBrowser.setImagesOnly();
    }
    this.assetBrowser.setVisibleTabs(options.visibleTabs || 'images');
    this.assetBrowser.setTabViewItem(options.activeTab || 'images');
    this.assetBrowser.loadAssetsByCompanyId(companyId, options);
  },

  _updateUploadMultiFilesMessage: function(onlyImages){
    jQuery('.js-filetype').text(onlyImages ? 'images' : 'files');
    jQuery('.js-librarytype').text(onlyImages ? 'image gallery' : 'file library');
  },

  isValidCompany: function(companyId) {
    return companyId === window.editor.currentCompanyId || companyId === window.editor.unbounceAssetsCompanyId;
  },

  //If the asset does not have a company id than get one from the server.
  companyIdByAssetUUID: function(assetUUID) {
    var companyId = window.editor.currentCompanyId;
    var url = endpoints.assetById(assetUUID);

    var response = new Ajax.Request(url, {
      method: 'get',
      contentType: 'application/json',
      asynchronous: false
    }).transport.response.evalJSON();

    if(response) {
      companyId = response.company_id;
    }

    if(window.editor.unbounceCompanyId === companyId) {
      companyId = window.editor.unbounceAssetsCompanyId;
    }
    return companyId;
  }
});



// WEBPACK FOOTER //
// ./src/lp/editor/ub-asset-chooser.js